'use client';

import React from 'react';
import {
  Container,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
  useDisclosure,
} from '@chakra-ui/react';
import Image from 'next/image';

import { IconButton, Modal, ModalCloseButton } from '@/components';
// import Cover1 from '@/images/aboutUs/cover-1.jpg';
import Cover2 from '@/images/aboutUs/cover-2.jpg';
// import Cover3 from '@/images/aboutUs/cover-3.jpg';
import Play from '@/svgs/dashboard/play.svg';

const LiaVideos: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [activeVideo, setActiveVideo] = React.useState<number | null>(null);

  const VIDEOS = [
    // {
    //   id: 0,
    //   cover: Cover1,
    //   src: 'https://liateam.arvanvod.ir/03rlgkloVm/OmdEdbay9B/origin_gO02x3A2D0zQ5OHDYdgqIBwVacDBDyGGImr6aHLM.mp4',
    // },
    // {
    //   id: 1,
    //   cover: Cover2,
    //   src: 'https://liateam.arvanvod.ir/03rlgkloVm/W3MdRy8j5K/origin_Z7B9GO1Cq5nnqykMADjgEoHtfXirg3EsHJHhDAmn.mp4',
    // },
    // {
    //   id: 2,
    //   cover: Cover3,
    //   src: 'https://liateam.arvanvod.ir/03rlgkloVm/K8ApOz0j5B/origin_ob1uXoxblw9tsCk2AMWxZxDiUvQNEaqndCT5ySyQ.mp4',
    // },
    {
      id: 0,
      cover: Cover2,
      src: 'https://liateam.arvanvod.ir/LYZGd8Gwlb/K0ZX7KX6Ak/origin_vVQSNk5ht7ni2LFAFHGgx7RB2QUYvWR21dI7XNMb.mp4',
    },
  ];

  const handlePlayButtonClick = (id: number) => {
    setActiveVideo(id);
    onOpen();
  };

  return (
    <Container>
      <Stack w="100%" mb={12} flexDir="row">
        <Stack w="100%" flexDir={{ base: 'column', md: 'row' }} gap={4}>
          {VIDEOS.map((video) => (
            <Stack
              key={video.id}
              flex={1}
              borderRadius={18}
              overflow="hidden"
              position="relative"
              alignItems="center"
              justifyContent="center"
            >
              <Stack
                width="100%"
                aspectRatio="16/9"
                bgColor="blackAlpha.600"
                alignItems="center"
                justifyContent="center"
                cursor="pointer"
                onClick={() => handlePlayButtonClick(video.id)}
              >
                <Image
                  src={video.cover}
                  alt="about-us-video"
                  layout="fill"
                  objectFit="cover"
                />
                <IconButton
                  width={{ base: '52px', md: '52px' }}
                  height={{ base: '52px', md: '52px' }}
                  aria-label="play"
                  icon={<Play />}
                  style={{ backgroundColor: 'transparent' }}
                />
              </Stack>
            </Stack>
          ))}
        </Stack>
        <Modal
          isCentered
          isOpen={isOpen}
          onClose={onClose}
          closeOnOverlayClick={false}
        >
          <ModalOverlay backdropFilter="blur(10px) hue-rotate(90deg)" />
          <ModalContent overflow="hidden" mx={2}>
            <Stack p={0} pos="absolute" top={0} left={0} zIndex={9}>
              <ModalCloseButton
                onClick={() => setActiveVideo(null)}
                sx={{ svg: { stroke: 'white' } }}
              />
            </Stack>
            <ModalBody p={0}>
              <video width="100%" src={VIDEOS[activeVideo || 0].src} controls />
            </ModalBody>
          </ModalContent>
        </Modal>
      </Stack>
    </Container>
  );
};

export default LiaVideos;
